import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateClearCandidateList = {
  clearCandidateList: { data: null, loading: false, error: null },
};

export const clearCandidateList = createAsyncThunk('user/clearCandidateList', async (vacancyId, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .delete(`${process.env.REACT_APP_SERVER_API}/vacancies/${vacancyId}/broadcast/candidates`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerClearCandidateList = {
  [clearCandidateList.pending]: (state) => {
    state.clearCandidateList.loading = true;
    state.clearCandidateList.error = null;
  },
  [clearCandidateList.fulfilled]: (state, action) => {
    state.clearCandidateList.loading = false;
    state.clearCandidateList.data = true;
    state.clearCandidateList.error = null;
  },
  [clearCandidateList.rejected]: (state, action) => {
    state.clearCandidateList.loading = false;
    state.clearCandidateList.error = true;
  },
};
